import { actions as billingActions } from '@/store/billing'
import { actions as paymentActions } from '@/store/payment'
import { actions as interactionActions } from '@/store/interaction'

const defaultActions = {};

function registerActions(actions) {
	const actionNames = Object.keys(actions);
	for (let i in actionNames) {
		const actionName = actionNames[i];
		defaultActions[actionName] = actions[actionName];
	}
};

registerActions(billingActions);
registerActions(paymentActions);
registerActions(interactionActions);

export default defaultActions;
